import React from "react";
import { FiPrinter, FiX } from "react-icons/fi";
import Logo from "../assets/logo1.png";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

  .inv-root {
    font-family: 'Montserrat', sans-serif;
  }

  .inv-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    padding: 16px;
  }

  .inv-modal {
    background: #ffffff;
    max-width: 56rem;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    border-radius: 12px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .inv-modal::-webkit-scrollbar {
    width: 6px;
  }

  .inv-modal::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 99px;
  }

  .inv-modal::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #2563eb, #8b5cf6);
    border-radius: 99px;
  }

  /* Header */
  .inv-header {
    background: linear-gradient(135deg, #1e3a5f, #2563eb);
    color: #ffffff;
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .inv-header-title {
    font-size: 24px;
    font-weight: 700;
  }

  .inv-header-sub {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
  }

  .inv-header-actions {
    display: flex;
    gap: 8px;
  }

  .inv-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }

  .inv-btn-print {
    background: #ffffff;
    color: #2563eb;
  }

  .inv-btn-print:hover {
    background: #eff6ff;
  }

  .inv-btn-close {
    background: rgba(255, 255, 255, 0.15);
    color: #ffffff;
  }

  .inv-btn-close:hover {
    background: rgba(255, 255, 255, 0.25);
  }

  /* Content */
  .inv-content {
    padding: 32px;
  }

  /* Company Header */
  .inv-company-section {
    border-bottom: 2px solid #2563eb;
    padding-bottom: 24px;
    margin-bottom: 24px;
  }

  .inv-company-flex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .inv-company-name {
    font-size: 28px;
    font-weight: 700;
    color: #1e3a5f;
    margin-bottom: 8px;
  }

  .inv-company-text {
    color: #6b7280;
    margin: 2px 0;
  }

  .inv-company-label {
    font-weight: 600;
  }

  .inv-gstin-box {
    background: #eff6ff;
    border: 1px solid #93c5fd;
    border-radius: 8px;
    padding: 16px;
    text-align: right;
  }

  .inv-gstin-label {
    font-size: 14px;
    color: #6b7280;
  }

  .inv-gstin-value {
    font-size: 18px;
    font-weight: 700;
    color: #1e3a5f;
  }

  /* Invoice Details */
  .inv-details-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 24px;
  }

  .inv-detail-box {
    background: #f9fafb;
    border-radius: 8px;
    padding: 16px;
  }

  .inv-detail-title {
    font-size: 18px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 12px;
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 8px;
  }

  .inv-detail-text {
    font-size: 14px;
    color: #6b7280;
  }

  .inv-detail-value {
    font-weight: 600;
  }

  .inv-detail-value-blue {
    font-weight: 600;
    color: #1e3a5f;
  }

  .inv-detail-row {
    display: flex;
    justify-content: space-between;
    margin: 4px 0;
  }

  /* Mobile Store Info */
  .inv-store-section {
    background: #eff6ff;
    border: 1px solid #93c5fd;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
  }

  .inv-store-title {
    font-size: 18px;
    font-weight: 700;
    color: #1e3a5f;
    margin-bottom: 8px;
  }

  .inv-store-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    font-size: 14px;
  }

  .inv-store-label {
    color: #6b7280;
  }

  .inv-store-value {
    font-weight: 600;
    color: #1f2937;
  }

  /* Items Table */
  .inv-items-section {
    margin-bottom: 24px;
  }

  .inv-items-title {
    font-size: 18px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 12px;
  }

  .inv-table-wrap {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
  }

  .inv-table {
    width: 100%;
    border-collapse: collapse;
  }

  .inv-table-head {
    background: #f3f4f6;
  }

  .inv-table-head th {
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
  }

  .inv-table-head th.center {
    text-align: center;
  }

  .inv-table-head th.right {
    text-align: right;
  }

  .inv-table-body tr {
    border-top: 1px solid #e5e7eb;
  }

  .inv-table-body td {
    padding: 12px 16px;
    font-size: 14px;
  }

  .inv-item-name {
    font-weight: 600;
    color: #1f2937;
  }

  .inv-item-desc {
    font-size: 12px;
    color: #6b7280;
  }

  .inv-item-center {
    text-align: center;
    font-weight: 600;
  }

  .inv-item-right {
    text-align: right;
  }

  .inv-item-pv {
    text-align: right;
    color: #7c3aed;
    font-weight: 600;
  }

  .inv-item-total {
    text-align: right;
    font-weight: 700;
    color: #1e3a5f;
  }

  /* Totals */
  .inv-totals-wrap {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 24px;
  }

  .inv-totals-box {
    width: 320px;
    background: #f9fafb;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e5e7eb;
  }

  .inv-totals-row {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }

  .inv-totals-label {
    color: #6b7280;
  }

  .inv-totals-value {
    font-weight: 600;
  }

  .inv-totals-divider {
    border-top: 1px solid #d1d5db;
    padding-top: 8px;
    margin-top: 8px;
  }

  .inv-grand-total {
    display: flex;
    justify-content: space-between;
  }

  .inv-grand-total-label {
    font-weight: 700;
    color: #1f2937;
  }

  .inv-grand-total-value {
    font-weight: 700;
    font-size: 20px;
    color: #1e3a5f;
  }

  .inv-total-pv {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    padding-top: 8px;
  }

  .inv-total-pv-label {
    color: #6b7280;
  }

  .inv-total-pv-value {
    font-weight: 600;
    color: #7c3aed;
  }

  /* Payment Info */
  .inv-payment-section {
    background: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
  }

  .inv-payment-title {
    font-size: 18px;
    font-weight: 700;
    color: #14532d;
    margin-bottom: 8px;
  }

  .inv-payment-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    font-size: 14px;
  }

  .inv-payment-label {
    color: #6b7280;
  }

  .inv-payment-value {
    font-weight: 600;
    color: #1f2937;
  }

  .inv-payment-status {
    padding: 4px 8px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
  }

  .inv-payment-status-delivered {
    background: #d1fae5;
    color: #065f46;
  }

  .inv-payment-status-cancelled {
    background: #fee2e2;
    color: #991b1b;
  }

  .inv-payment-status-pending {
    background: #fef3c7;
    color: #92400e;
  }

  .inv-transaction-id {
    font-weight: 600;
    color: #1f2937;
    font-family: 'Courier New', monospace;
  }

  /* Notes */
  .inv-notes-section {
    background: #fefce8;
    border: 1px solid #fde68a;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
  }

  .inv-notes-title {
    font-size: 18px;
    font-weight: 700;
    color: #78350f;
    margin-bottom: 8px;
  }

  .inv-notes-text {
    font-size: 14px;
    color: #374151;
  }

  /* Footer */
  .inv-footer {
    border-top: 1px solid #d1d5db;
    padding-top: 24px;
    margin-top: 24px;
  }

  .inv-footer-terms {
    text-align: center;
    font-size: 14px;
    color: #6b7280;
  }

  .inv-footer-terms-title {
    font-weight: 600;
    margin-bottom: 8px;
  }

  .inv-footer-contact {
    text-align: center;
    margin-top: 24px;
    font-size: 14px;
    color: #6b7280;
  }

  /* Print Styles */
  @media print {
    body * {
      visibility: hidden;
    }
    
    #invoice-content, #invoice-content * {
      visibility: visible;
    }
    
    #invoice-content {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      margin: 0;
      padding: 20px;
      background: white !important;
    }
    
    .inv-overlay {
      position: static;
      background: none;
      padding: 0;
    }
    
    .inv-modal {
      max-height: none;
      overflow: visible;
      border-radius: 0;
      box-shadow: none;
    }
    
    .inv-header, .inv-btn {
      display: none !important;
    }
    
    .inv-content {
      padding: 20px;
    }
  }

  /* Responsive */
  @media (max-width: 768px) {
    .inv-company-flex {
      flex-direction: column;
      gap: 16px;
    }

    .inv-details-grid {
      grid-template-columns: 1fr;
    }

    .inv-store-grid {
      grid-template-columns: 1fr;
    }

    .inv-payment-grid {
      grid-template-columns: 1fr;
    }

    .inv-totals-box {
      width: 100%;
    }

    .inv-header {
      flex-direction: column;
      gap: 12px;
      text-align: center;
    }

    .inv-table-wrap {
      overflow-x: auto;
    }

    .inv-table {
      min-width: 600px;
    }
  }
`;

const Invoice = ({ invoice, onClose, onPrint }) => {
  if (!invoice) return null;

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  const getPaymentStatusClass = (status) => {
    const classes = {
      delivered: "inv-payment-status-delivered",
      cancelled: "inv-payment-status-cancelled"
    };
    return classes[status] || "inv-payment-status-pending";
  };

  return (
    <div className="inv-root">
      <style>{styles}</style>
      
      <div className="inv-overlay">
        <div className="inv-modal">
          {/* Header */}
          <div className="inv-header">
            <div>
              <h2 className="inv-header-title">Invoice</h2>
              <p className="inv-header-sub">{invoice.invoiceNumber}</p>
            </div>
            <div className="inv-header-actions">
              <button
                onClick={onPrint}
                className="inv-btn inv-btn-print"
              >
                <FiPrinter /> Print
              </button>
              <button
                onClick={onClose}
                className="inv-btn inv-btn-close"
              >
                <FiX /> Close
              </button>
            </div>
          </div>

          {/* Invoice Content */}
          <div className="inv-content" id="invoice-content">
            {/* Company Header */}
            <div className="inv-company-section">
              <div className="inv-company-flex">
                <div className="flex items-center gap-4">
                  <img
                    src={Logo}
                    alt="ABM Group Logo"
                    className="w-20 h-20 object-contain"
                  />
                  <div>
                    <h1 className="inv-company-name">ABM GROUP one</h1>
                    {/* <p className="inv-company-text">India's most transparent and rewarding Hybrid MLM platform with Matrix + Generation plan.</p> */}
                    <p className="inv-company-text" style={{ marginTop: '8px' }}>
                      <span className="inv-company-label">Phone:</span> +91 8887355992
                    </p>
                    <p className="inv-company-text">
                      <span className="inv-company-label">Email:</span> support.abmgroupone@gmail.com
                    </p>
                    <p className="inv-company-text">
                      <span className="inv-company-label">Address:</span> Prayagraj, Uttar Pradesh, India - 212305
                    </p>
                    <p className="inv-company-text">
                      <span className="inv-company-label">Business Hours:</span> Mon-Sat: 10AM - 6PM
                    </p>
                  </div>
                </div>
                <div>
                  <div className="inv-gstin-box">
                    <p className="inv-gstin-label">GSTIN</p>
                    <p className="inv-gstin-value">27AAAC1234F1Z5</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Invoice Details */}
            <div className="inv-details-grid">
              <div className="inv-detail-box">
                <h3 className="inv-detail-title">Bill To</h3>
                <p className="inv-detail-value">{invoice.customer.name}</p>
                <p className="inv-detail-text">ID: {invoice.customer.uniqueId}</p>
                <p className="inv-detail-text">{invoice.customer.mobile}</p>
                <p className="inv-detail-text">{invoice.customer.email}</p>
                {/* <p className="inv-detail-text" style={{ marginTop: '8px' }}>{invoice.customer.address}</p> */}
              </div>
              <div className="inv-detail-box">
                <h3 className="inv-detail-title">Invoice Details</h3>
                <div className="inv-detail-row">
                  <span className="inv-detail-text">Invoice No:</span>
                  <span className="inv-detail-value-blue">{invoice.invoiceNumber}</span>
                </div>
                <div className="inv-detail-row">
                  <span className="inv-detail-text">Invoice Date:</span>
                  <span className="inv-detail-value">{formatDate(invoice.invoiceDate)}</span>
                </div>
                <div className="inv-detail-row">
                  <span className="inv-detail-text">Order Date:</span>
                  <span className="inv-detail-value">{formatDate(invoice.orderDate)}</span>
                </div>
                <div className="inv-detail-row">
                  <span className="inv-detail-text">Delivery Date:</span>
                  <span className="inv-detail-value">{formatDate(invoice.deliveryDate)}</span>
                </div>
              </div>
            </div>

            {/* Mobile Store Info */}
            <div className="inv-store-section">
              <h3 className="inv-store-title">Processed By</h3>
              <div className="inv-store-grid">
                <div>
                  <p className="inv-store-label">Store Name:</p>
                  <p className="inv-store-value">{invoice.mobileStore.shopName}</p>
                </div>
                <div>
                  <p className="inv-store-label">Store Owner:</p>
                  <p className="inv-store-value">{invoice.mobileStore.name} ({invoice.mobileStore.uniqueId})</p>
                </div>
                <div>
                  <p className="inv-store-label">Store Address:</p>
                  <p className="inv-store-value">{invoice.mobileStore.shopAddress}</p>
                </div>
                <div>
                  <p className="inv-store-label">Contact:</p>
                  <p className="inv-store-value">{invoice.mobileStore.mobile}</p>
                </div>
              </div>
            </div>

            {/* Items Table */}
            <div className="inv-items-section">
              <h3 className="inv-items-title">Order Items</h3>
              <div className="inv-table-wrap">
                <table className="inv-table">
                  <thead className="inv-table-head">
                    <tr>
                      <th>Item</th>
                      <th className="center">Qty</th>
                      <th className="right">MRP</th>
                      <th className="right">SP</th>
                      <th className="right">PV</th>
                      <th className="right">Total</th>
                    </tr>
                  </thead>
                  <tbody className="inv-table-body">
                    {invoice.items.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <p className="inv-item-name">{item.name}</p>
                          {item.description && (
                            <p className="inv-item-desc">{item.description}</p>
                          )}
                        </td>
                        <td className="inv-item-center">{item.quantity}</td>
                        <td className="inv-item-right">₹{item.mrp.toLocaleString("en-IN")}</td>
                        <td className="inv-item-right">₹{item.sp.toLocaleString("en-IN")}</td>
                        <td className="inv-item-pv">{item.pv}</td>
                        <td className="inv-item-total">₹{item.total.toLocaleString("en-IN")}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Totals */}
            <div className="inv-totals-wrap">
              <div className="inv-totals-box">
                <div className="inv-totals-row">
                  <span className="inv-totals-label">Subtotal:</span>
                  <span className="inv-totals-value">₹{invoice.totals.subtotal.toLocaleString("en-IN")}</span>
                </div>
                <div className="inv-totals-row">
                  <span className="inv-totals-label">Tax:</span>
                  <span className="inv-totals-value">₹{invoice.totals.tax.toLocaleString("en-IN")}</span>
                </div>
                <div className="inv-totals-row">
                  <span className="inv-totals-label">Shipping:</span>
                  <span className="inv-totals-value">₹{invoice.totals.shipping.toLocaleString("en-IN")}</span>
                </div>
                <div className="inv-totals-divider">
                  <div className="inv-grand-total">
                    <span className="inv-grand-total-label">Grand Total:</span>
                    <span className="inv-grand-total-value">₹{invoice.totals.total.toLocaleString("en-IN")}</span>
                  </div>
                </div>
                <div className="inv-total-pv">
                  <span className="inv-total-pv-label">Total PV:</span>
                  <span className="inv-total-pv-value">{invoice.totals.totalPv}</span>
                </div>
              </div>
            </div>

            {/* Payment Info */}
            <div className="inv-payment-section">
              <h3 className="inv-payment-title">Payment Information</h3>
              <div className="inv-payment-grid">
                <div>
                  <p className="inv-payment-label">Payment Method:</p>
                  <p className="inv-payment-value">{invoice.payment.method}</p>
                </div>
                <div>
                  <p className="inv-payment-label">Payment Status:</p>
                  <span className={`inv-payment-status ${getPaymentStatusClass(invoice.payment.status)}`}>
                    {invoice.payment.status.toUpperCase()}
                  </span>
                </div>
                <div>
                  <p className="inv-payment-label">Transaction ID:</p>
                  <p className="inv-transaction-id">{invoice.payment.transactionId}</p>
                </div>
              </div>
            </div>

            {/* Notes */}
            {invoice.notes && (
              <div className="inv-notes-section">
                <h3 className="inv-notes-title">Notes</h3>
                <p className="inv-notes-text">{invoice.notes}</p>
              </div>
            )}

            {/* Footer */}
            <div className="inv-footer">
              <div className="inv-footer-terms">
                <p className="inv-footer-terms-title">Terms & Conditions</p>
                <p>1. Goods once sold will not be taken back.</p>
                <p>2. Payment is due upon receipt.</p>
                <p>3. Please verify all items before signing.</p>
                <p>4. 7 days return policy applicable.</p>
                <p>5. All payments are subject to 5% TDS as per government norms.</p>
              </div>
              <div className="inv-footer-contact">
                <p>This is a computer-generated invoice and does not require a signature.</p>
                <p style={{ marginTop: '8px' }}>For queries, contact: support.abmgroupone@gmail.com | +91 8887355992</p>
                <p style={{ marginTop: '4px' }}>© {new Date().getFullYear()} ABM Group One. All rights reserved.</p>
                <p style={{ marginTop: '4px' }}>ISO 9001:2015 Certified</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;